import { render, staticRenderFns } from "./DeletePreset.vue?vue&type=template&id=46496594&"
import script from "./DeletePreset.vue?vue&type=script&lang=js&"
export * from "./DeletePreset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports